import { useState } from "react";
import { Link } from "react-router-dom";

import { resetPassword } from "../services/auth";

export default function ForgotPassword() {

    const [email, setEmail] = useState("");

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    async function handleSubmit(e) {

        e.preventDefault();

        setError("");
        setMessage("");

        try {

            setLoading(true);

            await resetPassword(email);

            setMessage(
                "If an account exists for that email, a password reset link has been sent."
            );

        } catch (err) {

            console.error(err);

            switch (err.code) {

                case "auth/invalid-email":
                    setError("Please enter a valid email address.");
                    break;

                default:
                    setError(err.message);

            }

        } finally {

            setLoading(false);

        }

    }

    return (

        <div
            className="page"
            style={{
                paddingTop: "calc(env(safe-area-inset-top) + 16px)"
            }}
        >

            <Link
                to="/login"
                style={{
                    display: "inline-block",
                    marginTop: "40px"
                }}
            >
                ← Back to Login
            </Link>

            <h1>Reset Password</h1>

            <p>
                Enter the email address associated with your account and we'll send you a password reset link.
            </p>

            <form onSubmit={handleSubmit}>

                <div style={{ marginBottom: "20px" }}>

                    <label>Email</label>

                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) =>
                            setEmail(e.target.value)
                        }
                    />

                </div>

                {error && (
                    <p style={{ color: "red" }}>
                        {error}
                    </p>
                )}

                {message && (
                    <p style={{ color: "green" }}>
                        {message}
                    </p>
                )}

                <button
                    type="submit"
                    disabled={loading}
                >
                    {loading
                        ? "Sending..."
                        : "Send Reset Email"}
                </button>

            </form>

        </div>

    );

}